<template>
    <b-modal :id="id" title="BootstrapVue" centered class="d-print-none">
        <template #modal-header="{ close }" class="border-0">
          <h5 class="text-center w-100 fw-bold" style="font-size: 16px;">
            Pilih halaman yang ingin diprint
          </h5>
        </template>
        <template #modal-footer="{ ok, hide }">
          <b-button variant="outline-dark" @click="$emit('cancel')" class="text-dark-blue">
            Batal
          </b-button>
          <b-button variant="success" @click="$emit('print')">
            <i class="fas fa-print"></i>
            Print
          </b-button>
        </template>
        <div class="d-flex flex-column gap-3">
          <div :class="`border border-2 p-3 rounded w-100 text-center`" role="button" @click="onClickAll" style="background: #F4F7FA">
            <div :class="`text-dark-blue`" style="font-size: 14px;">
              {{ !isAllSelected ? 'Pilih Semua': 'Batalkan Semua' }}
            </div>
          </div>
          <template  v-for="(item, key) in tableItems">
            <div v-bind:key="key" v-if="!item.alwaysPrint" :class="`border border-2 p-3 rounded-3 d-flex w-100 justify-content-between align-items-center ${item.$checked ? 'border-primary': ''}`" role="button" @click="onChecked(item)">
              <div :class="`${item.$checked ? 'text-primary' : 'text-black'}`" style="font-size: 14px;">
                {{ item.name }}
              </div>
              <div style="height: 24px" class="d-flex align-items-center">
                <i class="fa fa-check-circle text-success" v-if="item.$checked" style="font-size: large;"></i>
                <i class="far fa-circle" v-else style="font-size: large; color: #6C7589"></i>
              </div>
            </div>
          </template>
        </div>
    </b-modal>
</template>

<script>
export default {
  name: "modal-resume-export",
  props: {
    id: {type: String, default: 'export-modal'},
    value: {type: Array, default() { return [] }},
    items: {type: Array,default() { return [] }},
  },
  data() {
    return {
      tableItems: this.items,
      loading: false,
      isValid: true,
      errors: {},
      selected: [],
      selectedAll: null,
      // isAllSelected: false,
    }
  },
  computed: {
    isAllSelected: {
      get: function () {
        if (!this.tableItems.length) return false

        return this.tableItems.every(({$checked}) => $checked === true)
      },
      set: function (val) {
        if (!this.tableItems.length) return

        if (val) this.tableItems =  this.tableItems.map(item => ({...item, $checked: true}))
        else this.tableItems =  this.tableItems.map(item => ({...item, $checked: false}))
      }
    }
  },
  watch: {
    'tableItems': {
      deep: true,
      handler: function (val) {
        this.$emit('input', val.filter(({$checked}) => $checked).map(({value}) => value))
      }
    },
  },

  methods: {
    onChecked(item){
      this.$set(item, '$checked', !item.$checked)
    },
    onClickAll() {
      this.isAllSelected = !this.isAllSelected
    },
    selectAll() {
      this.tableItems.forEach(item => this.$set(item, '$checked', true))
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep{
  .custom-checkbox .custom-control-label::before {
    border-radius: 0.25rem;
  }
  .modal-header, .modal-footer {
    border: none !important;
  }
  
  @media print {
    .modal, .modal-backdrop {
      display: none !important;
    }
  }
}
</style>
